import { Field } from "formik";
import React from "react";
import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";

import { Textarea as TextareaElement, Wrapper, Count } from "./styles";

type IProps = any & IField

const Textarea = ({
  placeholder = "Digite aqui",
  required = false,
  name,
  title,
  prefixName = "",
  rows = 5,
  onChange,
  showCount = true,
  maxLenght = 1000,
  ...el
}: IProps): JSX.Element | null => {
  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target;
    if (onChange) {
      onChange(value);
    }
    if (el.validations?.includes("email")) value = event.target.value.replace(/\s/g, "");

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, value);
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Field {...el} name={`${prefixName}${name}`}>
        {({ field }: any) => (
          <Wrapper>
            <TextareaElement
              {...el}
              spellCheck="false"
              name={`${prefixName}${name}`}
              required={required}
              value={field.value}
              onChange={(event: any) => handleChange(event)}
              placeholder={placeholder || ""}
              rows={rows}
              maxLength={maxLenght}
            />
            {showCount && (
              <Count>{`${field.value.toString().length}/${maxLenght}`}</Count>
            )}
          </Wrapper>
        )}
      </Field>
    </TplGroup>
  );
};

export default Textarea;
